import React from 'react';

const Paragraph = ({ children }) => (
  <ul className="align-middle mt-4 mb-2 cursor-pointer ml-0 list-none">{children}</ul>
);

export default Paragraph;
